'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {
    SERVICES_PAGE_BREAD_CRUMB_CONTENT,
} from "../../common/constants/services";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import installation_services_top from '../../common/assets/images/services/installation-services/installation-services-top.webp';
import team_img from '@/app/[locale]/common/assets/images/about-us/img_about_us.webp';
import Image from "next/image";
import {Button} from "@/app/[locale]/common/components/Button/Button";
import {TInstallationServicesCardsContent, TServicesCardsContentIcon} from "@/app/[locale]/services/types";
import {CircleArrowIcon} from "@/app/[locale]/common/assets/CircleArrowIcon/CircleArrowIcon";
import {TextIconLink} from "@/app/[locale]/common/components/TextIconLink/TextIconLink";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {
    IndustriesCardsBlockSlider
} from "@/app/[locale]/common/components/IndustriesCardsBlockSlider/IndustriesCardsBlockSlider";
import {Link} from '@/i18n/routing';
import {useState} from "react";
import {ModalWindow} from "@/app/[locale]/common/components/ModalWindow/ModalWindow";
import {
    ContactUsModalWindowContent
} from "@/app/[locale]/common/components/ContactUsModalWindowContent/ContactUsModalWindowContent";
import {useTranslations} from "next-intl";
import {
    addDataToTranslatedArray
} from "@/app/[locale]/common/utils/functions/addDataToTranslatedArray/addDataToTranslatedArray";
import {ManPhoneIcon} from "@/app/[locale]/common/assets/ManPhoneIcon/ManPhoneIcon";
import {SpannerIcon} from "@/app/[locale]/common/assets/SpannerIcon/SpannerIcon";
import {DataMonitoringIcon} from "@/app/[locale]/common/assets/DataMonitoringIcon/DataMonitoringIcon";
import {SupportIcon} from "@/app/[locale]/common/assets/SupportIcon/SupportIcon";
import {DocumentIcon} from "@/app/[locale]/common/assets/DocumentIcon/DocumentIcon";
import {RemoteManagementIcon} from "@/app/[locale]/common/assets/RemoteManagementIcon/RemoteManagementIcon";
import {DollarCircleIcon} from "@/app/[locale]/common/assets/DollarCircleIcon/DollarCircleIcon";

export default function InstallationServicesPage() {
    const t = useTranslations('InstallationServicesPage');
    const expectBlockCardsData: TServicesCardsContentIcon[] = addDataToTranslatedArray(t.raw('expectBlock.cardsData'), [ManPhoneIcon, SpannerIcon, DataMonitoringIcon, SupportIcon], 'Icon');
    const mattersBlockCardsData: TServicesCardsContentIcon[] = addDataToTranslatedArray(t.raw('mattersBlock.cardsData'), [DocumentIcon, RemoteManagementIcon, DollarCircleIcon], 'Icon');


    const [ isOpenModalWindow, setIsOpenModalWindow ] = useState(false);
    const openModalWindow = () => setIsOpenModalWindow(true);
    const closeModalWindow = () => setIsOpenModalWindow(false);

    return (
        <div className={s.installationServices}>
            <Container>
                <Breadcrumbs crumb={[SERVICES_PAGE_BREAD_CRUMB_CONTENT.SERVICES, SERVICES_PAGE_BREAD_CRUMB_CONTENT.INSTALLATION_SERVICES]} />

                <div className={s.installationServices_top}>
                    <Title title={t('title')} />

                    <div className={s.installationServices_flexContainer}>
                        <div className={s.installationServices_imageContainer}>
                            <Image src={installation_services_top} alt={'installation_services_top'} />
                        </div>

                        <div className={s.installationServices_top_content_text}>
                            <p className={s.installationServices_text} dangerouslySetInnerHTML={{__html: t.raw('topBlock.text')}} />
                            <p className={s.installationServices_text}>{ t('topBlock.secondText') }</p>
                            <Button size={'medium'} onClick={openModalWindow}>{t('topBlock.button')}</Button>
                        </div>
                    </div>
                </div>

                <div className={s.installationServices_about}>
                    <Title title={t('aboutBlock.title')} />

                    <div className={s.installationServices_flexContainer}>
                        <div className={s.installationServices_about_content}>
                            <p className={s.installationServices_text}>{t('aboutBlock.firstText')}</p>
                            <p className={s.installationServices_text} dangerouslySetInnerHTML={{__html: t.raw('aboutBlock.text')}}/>
                        </div>

                        <div className={`${s.installationServices_about_imageContainer} ${s.installationServices_imageContainer}`}>
                            <Image src={team_img} alt={'team'} />
                        </div>
                    </div>
                </div>

                <div className={s.installationServices_expect}>
                    <Title title={t('expectBlock.title')} />
                    <p className={`${s.installationServices_expect_text} ${s.installationServices_text}`}>{ t('expectBlock.text') }</p>

                    <div className={s.installationServices_expect_cardsContainer}>
                        {
                            expectBlockCardsData.map((item: TServicesCardsContentIcon, index: number) => (
                                <div key={index} className={s.installationServices_expect_card}>
                                    <div className={s.installationServices_expect_card_iconContainer}>{ <item.Icon /> }</div>
                                    <label className={s.installationServices_label}>{ item.label }</label>
                                    <p className={s.installationServices_text}>{ item.text }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <IndustriesCardsBlockSlider
                    title={t('industriesBlock.title')}
                    text={t('industriesBlock.text')}
                    data={t.raw('industriesBlock.cardsData')}
                />

                <div className={s.installationServices_products}>
                    <Title title={t('productsBlock.title')} />
                    <p className={`${s.installationServices_products_text} ${s.installationServices_text}`}>{ t('productsBlock.text') }</p>

                    <div className={s.installationServices_products_cardsContainer}>
                        {
                            t.raw('productsBlock.cardsData').map((item: TInstallationServicesCardsContent, index: number) => (
                                <div key={index} className={s.installationServices_products_card}>
                                    <Link href={item.href} className={`${s.installationServices_products_card_imageContainer} ${item.imageMob ? s.installationServices_products_card_imageContainerHidden : ''}`}>
                                        <Image src={item.image} alt={item.label} />
                                    </Link>

                                    {
                                        item.imageMob &&
                                        <Link href={item.href} className={`${s.installationServices_products_card_imageContainer} ${s.installationServices_products_card_imageContainerMobVersion}`}>
                                            <Image src={item.imageMob} alt={item.label} />
                                        </Link>
                                    }

                                    <div className={s.installationServices_products_card_content}>
                                        <label className={s.installationServices_label}>{ item.label }</label>
                                        <p className={s.installationServices_text}>{ item.text }</p>

                                        <TextIconLink
                                            icon={<CircleArrowIcon />}
                                            href={item.href}
                                        >
                                            { t('productsBlock.button') }
                                        </TextIconLink>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                
                <div className={s.installationServices_matters}>
                    <Title title={t('mattersBlock.title')} />
                    <p className={`${s.installationServices_matters_text} ${s.installationServices_text}`}>{ t('mattersBlock.text') }</p>

                    <div className={s.installationServices_matters_cardsContainer}>
                        {
                            mattersBlockCardsData.map((item: TServicesCardsContentIcon, index: number) => (
                                <div key={index} className={s.installationServices_matters_card}>
                                    <div className={s.installationServices_matters_card_iconContainer}>{ <item.Icon /> }</div>

                                    <label className={s.installationServices_label}>{ item.label }</label>
                                    <p className={s.installationServices_text}>{ item.text }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <Title title={t('contacts.title')} />
                <p className={`${s.installationServices_text} ${s.installationServices_contact_text}`}>{ t('contacts.text') }</p>
                <ContactUs title={false} />

                <ModalWindow isOpen={isOpenModalWindow} closeModalWindow={closeModalWindow}>
                    <ContactUsModalWindowContent />
                </ModalWindow>
            </Container>
        </div>
    );
};